import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { SENTINEL2 } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

const id = 'Sentinel2Transparent'
const authId = 'sentinel'
const datetimeId = 'Sentinel2'
const SOURCE_URL = SENTINEL2

class Sentinel2 extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props

    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time, url = SENTINEL2, format='png' } = this.props

    const visible = layerRendered
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''

    const rasterSource = {
      type: 'raster',
      tiles: [url({ idToken, timeIso, format })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return [
        <Source
        key={`${id}Key`}
        id={id}
        tileJsonSource={rasterSource}
        minzoom={5}
        maxzoom={13}
      />,
      <Layer
        key={`${id}Layer`}
        type='raster'
        id={id}
        sourceId={id}
        layout={{
          visibility: visible ? 'visible' : 'none'
          // 'raster-fade-duration': 300
        }}
        paint={paint}
        before={before}
      />
    ]
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
        const mapStateToProps = (state) => {

          return {            
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, 'default'),
            paint: getPaint(state, id),
            time: state.layer.times.RiverIce || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(Sentinel2)



// WEBPACK FOOTER //
// ./src/layers/Sentinel2Transparent.js